import type { KintoneSystem } from "~/functions/api/kintoneSystem";

/**
 * kintone スペースURLを生成
 */
export const buildKintoneSpaceUrl = (system: KintoneSystem): string | undefined => {
  if (system.space?.id && system.subdomain) {
    return `https://${system.subdomain}.cybozu.com/k/#/space/${system.space.id}`;
  }
  return undefined;
};

/**
 * サブドメインとスペースIDからkintone URLを生成
 */
export const buildKintoneSpaceUrlFromParams = (
  subdomain: string,
  spaceId: string | undefined,
): string | undefined => {
  if (spaceId && subdomain) {
    return `https://${subdomain}.cybozu.com/k/#/space/${spaceId}`;
  }
  return undefined;
};
